// startup
// Load entry module and return exports
// This entry module is referenced by other modules so it can't be inlined
__webpack_require__("./src/main/resources/static/javascript/autocontextualization/autocontextualization.src.js");
let __webpack_exports__ = __webpack_require__("./src/main/resources/static/sass/autocontextualization/autocontextualization.src.scss");
